import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  '!FETCH_ONBOARDING_DOCUMENTS',
  '!REMOVE_ONBOARDING_DOCUMENT',
  '!UPLOAD_ONBOARDING_DOCUMENTS',
] as const

export default serviceActionsGenerator('onboardingDocuments', actionTypes)
